import printJS from "print-js";
import { api_URL } from "./Constantes";

export const PrintOpService = (numpiece, docName) => {
  // Vérifiez si le nom du document est fourni, sinon utilisez le document par défaut "Ordre_Paiement"
  const documentName = docName || "Ordre_Paiement"||"Ordre_Virement_DIVERS";
  const userId = localStorage.getItem('login');
  const username = localStorage.getItem('username');
  const url = `${api_URL}/Print/LettreCheque?docName=${documentName}&numpiece=${numpiece}`;

  fetch(url, {
    method: 'GET',
    headers: {
      'user_id':userId,
      'username': username,
    },
  })
    .then(response => response.blob())
    .then(blob => {
      const file = new Blob([blob], { type: 'application/pdf' });
      const fileURL = URL.createObjectURL(file);

      // Utilisez printJS pour imprimer le PDF
      printJS(fileURL);
    })
    .catch(error => console.error('Erreur lors de la récupération du PDF', error));
};
/* 
 AddFacture = async (docData) => {
    try {
      const response = await api.post(`/Facture/add`, docData , 
      {
         headers: {
            'user_id': 'xxxx' 
          } 
        }) 
      
      // Ajoutez une console.log pour afficher la réponse du serveur
      console.log('Réponse du serveur après l\'ajout de la facture :', response.data);

      return response.data;
    } catch (error) {
      console.error('Erreur lors de l\'ajout de la facture :', error);
      // Assurez-vous que la promesse est rejetée pour propager l'erreur
      throw error;
    }
  };

  EditFacture = async (numenreg, docData) => {
    try {
      const response = await api.put(`/Facture/${numenreg}`, docData);
      return response.data;
    } catch (error) {
      console.error('Erreur lors de la mise à jour des données :', error);
    }
  };
  
      deleteFacture = async (numenreg) => {
        try {
          const response = await api.delete(`/Facture/${numenreg}`);
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
        
        }
      };

      getParamComptable = async () => {
        try {
          const response = await api.get(`/InfosGen/DateCompta/param3`, {
         
          });
          return response.data;
        } catch (error) {
          console.error('Erreur lors de la récupération des données :', error);
          // Gérer l'erreur ici si nécessaire
          throw error; 
        }
      };
        ImportFile = async (numenreg, formData) => {
          try {
            const response = await api.post(`/Facture/uploadFile/${numenreg}?facture`, formData, {
                headers: {
                  'Content-Type': 'multipart/form-data',
                },
              });
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la récupération des données :', error);
            throw error;
          }
        };
         
        getOneListTraitementFact = async (fournisseurId) => {
          try {
            const response = await api.get(`/Document/ByFacture/list/IPM/${fournisseurId}`, {
           
            });
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la récupération des données :', error);
            // Gérer l'erreur ici si nécessaire
            throw error; 
          }
        };
        getOneListTraitementFourn = async (fournisseurId) => {
          try {
            const response = await api.get(`/Document/ByFourn/list/IPM/${fournisseurId}`, {
           
            });
            return response.data;
          } catch (error) {
            console.error('Erreur lors de la récupération des données :', error);
            // Gérer l'erreur ici si nécessaire
            throw error; 
          }
        };
*/